export default __webpack_public_path__ + "static/media/tela_cloudmanagedservicesenterprise.72e08528.png";